export default __webpack_public_path__ + "static/media/A0003.61f4f8e1.png";